import React from 'react';
import { Container, Box, Typography, Grid, Card, CardContent } from '@mui/material';
import { Email, Phone, LocationOn } from '@mui/icons-material';

const Contact = () => {
    return (
        <Container
            maxWidth="lg"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '16px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                padding: 4,
                marginTop: '10px',
            }}
        >
            <Box sx={{ mb: 4, textAlign: 'center' }}>
                <img
                    src="../images/logoo.png"
                    alt="Logo Stowarzyszenia"
                    style={{
                        width: '250px',
                        height: '250px',
                        borderRadius: '5%',
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.5)',
                    }}
                />
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        mt: 2,
                        fontWeight: 'bold',
                        color: 'primary.main',
                        textShadow: '1px 1px 4px rgba(0, 0, 0, 0.3)',
                    }}
                >
                    <br />Kontakt
                </Typography>
            </Box>
            <Grid
                container
                spacing={4}
                sx={{
                    width: '100%',
                    justifyContent: 'center',
                }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <Card
                        sx={{
                            boxShadow: 4,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                        }}
                    >
                        <CardContent sx={{ textAlign: 'center' }}>
                            <LocationOn sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Adres
                            </Typography>
                            <Typography variant="body1">
                                Ul. Piotra Wysockiego 4/19<br />
                                27-200 Starachowice
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card
                        sx={{
                            boxShadow: 4,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                        }}
                    >
                        <CardContent sx={{ textAlign: 'center' }}>
                            <Email sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                E-mail
                            </Typography>
                            <Typography variant="body1">
                                aktywnistarachowice@gmail.com<br />
                                <br></br>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card
                        sx={{
                            boxShadow: 4,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                        }}
                    >
                        <CardContent sx={{ textAlign: 'center' }}>
                            <Phone sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Telefon
                            </Typography>
                            <Typography variant="body1">
                                +48 573 304 368<br />
                                +48 507 710 765
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Box
                sx={{
                    mt: 6,
                    textAlign: 'center',
                    color: 'text.secondary',
                    fontSize: 14,
                }}
            >
                <Typography>
                    &copy; {new Date().getFullYear()} Aktywni Starachowice. Wszystkie prawa zastrzeżone.
                </Typography>
            </Box>
        </Container>
    );
};

export default Contact;
